module.exports = __webpack_public_path__ + "static/img/user1.f8c2d1d8.png";